<template lang="pug">
  #mental-wellness-reports.box
    WtTile(ancestor :col="12")
    .card.mb-4(v-if="showAssessmentReport")
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="6").no-padding
            WtTitle(h5) Plan Assessment Report
            small A summary of all users plan assessment details.
          WtTile(child :col="6").no-padding
            WtTile(parent :col="12").no-padding
              WtTile(child :col="8").no-padding
              WtTile(child :col="4").no-padding
                BField(:message="assessmentReportEmailSent ? 'Email Sent' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingAssessmentReport"
                    @click.native="assessmentReport"
                  ) DOWNLOAD

    .card.mb-4(v-if="showAssessmentReport")
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="6").no-padding
            WtTitle(h5) Plan Assessment Questions Report
            small An anonymous summary of all users plan assessment responses.
          WtTile(child :col="6").no-padding
            WtTile(parent :col="12").no-padding
              WtTile(child :col="8").no-padding
              WtTile(child :col="4").no-padding
                BField(:message="assessmentQuestionsReportEmailSent ? 'Email Sent' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingAssessmentQuestionsReport"
                    @click.native="assessmentQuestionsReport"
                  ) DOWNLOAD
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";

export default {
  name: "MentalWellnessReports",

  components: {
    WtButton,
    WtTitle,
    WtTile
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    fetchMembersAction: {
      type: Function,
      required: true
    },
    members: {
      type: Object,
      default: () => null
    }
  },

  data() {
    return {
      assessmentReportEmailSent: false,
      assessmentQuestionsReportEmailSent: false,
      processingAssessmentReport: false,
      processingAssessmentQuestionsReport: false
      //TO-DO: use a map in future for loading animation and Email sent state
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta", "isCoreTier", "isProTier"]),

    showAssessmentReport() {
      return true;
    }
  },

  methods: {
    ...mapActions("program", [
      "userAssessmentStatusDownload",
      "userAssessmentQuestionsDownload"
    ]),
    ...mapActions(["snackBar"]),

    async assessmentReport() {
      this.processingAssessmentReport = true;
      this.assessmentReportEmailSent = false;
      const payload = {
        programId: this.coreProgramMeta.id
      };

      let response = await this.userAssessmentStatusDownload(payload);

      var jsonResponse = false;
      try {
        // This errors when the arraybuffer is a csv...
        jsonResponse = JSON.parse(
          new TextDecoder().decode(new Uint8Array(response.data))
        );
      } catch (e) {
        jsonResponse = false;
      }
      try {
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
          this.assessmentReportEmailSent = true;
        } else if (this._.has(response, "data")) {
          const mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: mimeType });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.download = `user_assessment_report`;
          a.href = downloadUrl;

          document.body.appendChild(a);

          a.click();
        }
      } catch (error) {
        this.snackBar({
          duration: 10000,
          type: "is-danger",
          message: this._.get(
            error,
            "data.error.message",
            `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
          )
        });
        console.log(
          "🚀 ~ file: MentalWellnessReports.vue ~ downloadAssessmentReport ~ error",
          error
        );
      }

      this.processingAssessmentReport = false;
    },

    async assessmentQuestionsReport() {
      this.processingAssessmentQuestionsReport = true;
      this.assessmentQuestionsReportEmailSent = false;
      const payload = {
        programId: this.coreProgramMeta.id
      };

      let response = await this.userAssessmentQuestionsDownload(payload);

      var jsonResponse = false;
      try {
        jsonResponse = JSON.parse(
          new TextDecoder().decode(new Uint8Array(response.data))
        );
      } catch (e) {
        jsonResponse = false;
      }
      try {
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
          this.assessmentQuestionsReportEmailSent = true;
        } else if (this._.has(response, "data")) {
          const mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: mimeType });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.download = `user_assessment_questions_report`;
          a.href = downloadUrl;

          document.body.appendChild(a);

          a.click();
        }
      } catch (error) {
        this.snackBar({
          duration: 10000,
          type: "is-danger",
          message: this._.get(
            error,
            "data.error.message",
            `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
          )
        });
        console.log(
          "🚀 ~ file: MentalWellnessReports.vue ~ downloadAssessmentReport ~ error",
          error
        );
      }

      this.processingAssessmentQuestionsReport = false;
    }
  }
};
</script>

<style lang="sass" scoped>
.no-padding
  padding: 0px

small
  color: $grey
  font-size: 12px

.mt-5
  margin-top: 31px !important

.reportTile
  background-color: $grey-lighter

  .wt-tile
    background-color: $grey-lighter

.card
  overflow: visible
</style>
